import {useMemo} from 'react'
import {useInfiniteQuery} from 'react-query'
import {KTCard, QUERIES} from '../../../../../_metronic/helpers'
import {QueryRequestProvider} from '../../../../../_metronic/common/table/core/QueryRequestProvider'
import {QueryResponseProvider} from '../../../../../_metronic/common/table/core/QueryResponseProvider'
import {ListViewProvider, useListView} from '../../../../../_metronic/common/table/core/ListViewProvider'
import {Table} from '../../../../../_metronic/common/table/Table'
import {EditModal} from '../../../../../_metronic/common/edit-modal/EditModal'
import {UserModel} from '../../../auth'
import {getStockCategories} from './core/_requests'
import {stockCategoryColumns} from './table/columns/_columns'
import {StockCategoriesListHeader} from './components/header/StockCategoriesListHeader'
import {StockCategoryEditModalFormWrapper} from './stock-category-edit-modal/StockCategoryEditModalFormWrapper'

const useStockCategories = (query: string, currentUser: UserModel | undefined) => {
  return useInfiniteQuery(
    `${QUERIES.STOCK_CATEGORIES_LIST}-${query}`,
    ({pageParam}) => getStockCategories(query, currentUser, pageParam),
    {
      getNextPageParam: (lastPage) => lastPage.data?.LastEvaluatedKey,
      refetchInterval: 10000,
    }
  )
}

const StockCategoriesList = () => {
  const {itemIdForUpdate} = useListView()
  const columns = useMemo(() => stockCategoryColumns, [])

  return (
    <>
      <KTCard>
        <StockCategoriesListHeader />
        <Table columns={columns} />
      </KTCard>
      {itemIdForUpdate !== undefined && (
        <EditModal title={itemIdForUpdate === null ? 'Add Stock Category' : 'Edit Stock Category'}>
          <StockCategoryEditModalFormWrapper />
        </EditModal>
      )}
    </>
  )
}

const StockCategoriesListWrapper = () => {
  return (
    <QueryRequestProvider>
      <QueryResponseProvider useDataQuery={useStockCategories}>
        <ListViewProvider>
          <StockCategoriesList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export {StockCategoriesListWrapper}
